import { render, staticRenderFns } from "./PageReviews.vue?vue&type=template&id=05bbe80b&scoped=true&"
import script from "./PageReviews.vue?vue&type=script&lang=js&"
export * from "./PageReviews.vue?vue&type=script&lang=js&"
import style0 from "./PageReviews.vue?vue&type=style&index=0&id=05bbe80b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bbe80b",
  null
  
)

export default component.exports